<template>
    <div class="record-cell" :style="!active ? {paddingLeft: '5px'} : {}">
        <!-- 我的预约 -->
        <div v-if="isBooking" class="info-x" @click="checkDetail(item)">
            <hua-image
                class="m-t-30"
                fit="cover"
                width="70px"
                height="70px"
                :src="item.v_capturePic ? item.v_capturePic : image"
            ></hua-image>
            <div class="info-detail">
                <div class="v-name">
                    <span class="text-color"
                        >访客姓名：<span class="text-color">{{
                            item.v_name.length > 5 ? item.v_name.slice(0, 5) + '...' : item.v_name
                        }}</span
                        >&nbsp;&nbsp;
                        <hua-tag
                            v-model="value"
                            round
                            marketing
                            plain
                            :type="item.v_personSum > 1 ? 'warning' : 'primary'"
                            >{{ item.v_personSum > 1 ? '多人' : '单人' }}</hua-tag
                        >
                    </span>
                    <span v-if="item.status === 0" class="wait-audit status-box">{{ item.statusName || '待审核' }}</span>
                    <span v-else-if="item.status === 1" class="book-success status-box">预约成功</span>
                    <span v-else-if="item.status === 2" class="off status-box">{{ item.statusName || '在访' }}</span>
                    <span v-else-if="item.status === 3" class="book-cancel status-box">{{
                        item.statusName || '离访'
                    }}</span>
                    <span v-else-if="item.status === 4" class="book-fail status-box">预约取消</span>
                </div>
                <div class="text-color">
                    来访事由：<span class="text-color">{{
                        item.v_reason && item.v_reason.length > 10
                            ? item.v_reason.slice(0, 10) + '...'
                            : item.v_reason
                    }}</span>
                </div>
                <div class="text-color">
                    预约来访时间：<span class="text-color">{{
                        item.v_timeStr || item.v_time
                    }}</span>
                </div>
            </div>
        </div>
        <!-- 审批页面 -->
        <div v-else class="info-x new-item" @click="checkDetail(item)">
            <div class="top-box" :style="active === 0 ? '' : 'padding-left: 0;width: 100%;'">
                <hua-image
                    class="m-t-30 person-img"
                    fit="cover"
                    width="50px"
                    height="50px"
                    :src="item.v_capturePic ? item.v_capturePic : image"
                ></hua-image>
                <div class="right-info">
                    <div class="name">{{item.v_name}}</div>
                    <div class="phone">
                        <span v-if="item.v_plateNumber">{{item.v_plateNumber}} /</span>
                        <span> {{item.v_phone}}</span>
                        <img src="@/image/spgl_button_tel_default.png" alt="">
                    </div>
                    <div :class="{
                        'mytag-box': true,
                        'wait-audit': active === 0, // 待审核
                        'visiting': active === 1, // 在访
                        'leave-visit': active === 2, // 离访
                        'cancel-visit': active === 3, // 取消
                        'visit-success': active === 4, // 预约成功
                    }">
                        {{statusTextMap[active]}}
                    </div>
                </div>
            </div>
            <div class="info-detail">
                <div class="v-name" style="margin-top:10px;">
                    <span class="text-color">
                        <img class="my-icon" src="@/image/spgl_pic_peo.png" alt="">
                        受访人：{{item.isv_name}}<span>{{item.isv_id ? `(${item.isv_id})` : ''}}</span>
                    </span>
                </div>
                <div class="text-color middle">
                    <img class="my-icon" src="@/image/spgl_pic_time.png" alt="">
                    <span class="text-color time-text">
                        {{ item.v_timeStr }} 至 {{ item.v_lvTimeStr }}
                    </span>
                </div>
                <div v-if="item.v_reason" class="text-color">
                    <span class="text-color">
                        来访事由：{{ item.v_reason }}
                    </span>
                </div>
                <div v-if="active === 2" class="leave-time">
                    离访时间：{{ item.v_lvTimeStr }}
                </div>
            </div>
            <div v-if="active === 0" class="operate-box">
                <hua-button class="opt-btn" @click.stop="btnClick(1, item)" type="default" size="small" block>通过</hua-button>
                <hua-button class="opt-btn" @click.stop="btnClick(2, item)" type="default" size="small" block>驳回</hua-button>
            </div>
        </div>
        <hua-dialog
            v-model="isConfirmShow"
            :showCancelButton="true"
            confirm-button-color="#007aff"
            cancel-button-color="#1a1a1a"
            :overlay="true"
            @confirm="handleConfirm"
            @cancel="isConfirmShow = false"
            @click.prevent="() => {}"
        >
            <div class="my-confirm-content">确认{{confirmMsg}}</div>
      </hua-dialog>
    </div>
</template>

<script>
import image from '@/image/head.jpg'
import api from '@/constants/api'
export default {
    props: {
        item: {
            type: Object,
            default() {
                return {}
            },
        },
        v_personid: {
            type: String,
        },
        active: {
            // require: true,
            type: [Number, String],
        },
        // 是否为我的预约
        isBooking: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            value: true,
            image: image,
            fits: ['contain', 'cover', 'fill', 'none', 'scale-down'],
            confirmMsg: '', // 通过，驳回
            isConfirmShow: false,
            nowItem: {}, // 当前通过或驳回的项
            // 状态值转换文字
            statusTextMap: {
                0: '待审核',
                1: '在访',
                2: '离访',
                3: '取消',
                4: '预约成功',
            },
            areaIdList: [],
        }
    },
    methods: {
        // 确认
        async handleConfirm() {
            console.log('confirmMsg', this.confirmMsg);
            console.log('this.nowItem111', this.nowItem);
            try {
                const params = {
                    appointTime: new Date().getTime(),
                    id: this.nowItem.id,
                    personId: localStorage.getItem('v_personid') ? JSON.parse(localStorage.getItem('v_personid')) : '',
                    // personId: Number(this.nowItem.isv_id),
                    visitorType: 2,
                }
                if(this.confirmMsg === '通过') {
                    params.times = 999
                    params.result = true
                    params.areaIdList = this.areaIdList
                    params.secondVisitorType = this.nowItem.secondVisitorType
                } else {
                    params.result = false
                    params.isv_id = this.nowItem.isv_id
                }
                const res = await api.review(params)
                console.log('ressss111', res)
                if(res.success) {
                    this.$toast(`${this.confirmMsg}成功！`)
                    this.$emit('refreshData')
                } else {
                    this.$toast(`${this.confirmMsg}失败！`)
                }
            } catch(err) {
                console.log(err)
                this.$toast(err.errMsg || `${this.confirmMsg}失败！`)
            } finally {
                this.isConfirmShow = false
            }
        },
        async btnClick(flag, nowItem) {
            // flag===1通过，2驳回
            this.confirmMsg = flag === 1 ? '通过' : '驳回'
            this.nowItem = nowItem
            console.log('msgmsgmsg', this.confirmMsg);
            if(flag === 1) {
                // 通过时，先去详情接口获取areaIdList
                try {
                    const res = await api.getVisitorInfoById1({
                        id: nowItem.id
                    })
                    console.log('详情res=====', res)
                    if(res.success) {
                        this.areaIdList = res.data.areaIdList || []
                        this.isConfirmShow = true
                    } else {
                        this.$toast(res.errMsg || '获取详情失败')
                    }
                } catch(err) {
                    console.log('详情err', err);
                    this.$toast(err.errMsg || '获取详情失败！')
                }
            } else {
                // 驳回不需要
                this.isConfirmShow = true
            }
        },
        checkDetail(item) {
            if (this.active === 'mylist') {
                if (item.status === 0) {
                    this.$toast.fail('待审核')
                } else if (item.status === 3) {
                    this.$toast.fail('已离访')
                } else if (item.status === 4) {
                    this.$toast.fail('不通过')
                } else if (item.status === 1 || item.status === 2) {
                    let params = {
                        v_barCode: item.v_barCode,
                        appointmentCode: item.appointmentCode,
                        needReview: false,
                        active: 1,
                    }
                    this.$router.push({ name: 'bookInviteSuccess', params: params })
                }
            } else {
                let params = {
                    v_personid: this.v_personid,
                    isv_id: item.isv_id,
                    id: item.id,
                    v_timeStr: item.v_timeStr,
                    active: this.active === 0 ? 'audit' : 'detail',
                    v_healthCodePic: item.v_healthCodePic,
                    reviewable: item.reviewable,
                    showOrg: true
                }
                this.$router.push({ name: 'bookDetail', params: params })
            }
        },
    },
}
</script>
<style lang="less">
.record-cell {
    width: 100%;
    // height: 70px;
    // margin-bottom: 15px;
    // background-color: #fff;
    padding: 10px;
    box-sizing: border-box;
    .info-x {
        display: flex;
        padding: 10px;
        background-color: #ffffff;
        .hua-image__img {
            border-radius: 10px;
        }
    }
    .info-detail {
        color: #445160;
        margin-left: 12px;
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: space-between;
    }
    .v-name {
        display: flex;
        justify-content: space-between;
    }
    .hua-tag--primary.hua-tag--plain {
        height: 14px;
        background-color: #e6f3ff;
        border: transparent;
    }
    .hua-tag--warning.hua-tag--plain {
        height: 14px;
        background-color: #fff3e4;
        border: transparent;
    }
    .text-color {
        color: #666;
    }
    .wait-audit {
        color: #bfbfbf;
    }
    .book-success {
        color: #61b77e;
    }
    .status-box {
        display: inline-block;
        min-width: 60px;
    }
}
</style>
<style lang="less" scoped>
.new-item {
    padding: 0;
    width: 100%;
    display: unset;
    margin-top: 10px;
    overflow: hidden;
    .top-box {
        display: flex;
        width: calc(100% - 30px);
        padding-left: 30px;
        .person-img {
            margin-right: 5px;
            border-radius: 5px;
            overflow: hidden;
        }
        .right-info {
            position: relative;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            .name {
                width: 80%;
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .phone {
                width: 100%;
                display: flex;
                align-items: center;
                img {
                    margin-left: 3px;
                    width: 8px;
                }
            }
            .mytag-box {
                position: absolute;
                top: 0;
                right: 0;
                height: 18px;
                line-height: 18px;
                padding: 0 5px;
                font-size: 10px;
                color: #ffffff;
                border-radius: 3px;
            }
            // 待审核
            .wait-audit {
                background-color: #ffb128;
            }
            // 取消
            .cancel-visit {
                background-color: #dddddd;
                color: #666666;
            }
            // 离访
            .leave-visit {
                background-color: #0a86ff;
            }
            // 在访
            .visiting {
                background-color: #01b915;
            }
            // 预约成功
            .visit-success {
                background-color: #01b915;
            }
        }
    }
    .middle {
        display: flex;
        align-items: center;
        margin: 10px 0;
        .time-text {
            width: calc(100% - 14px);
        }
    }
    .leave-time {
        text-align: center;
        font-size: 10px;
        color: #a1a1a1;
    }
    .my-icon {
        margin-right: 5px;
        width: 14px;
    }
    .operate-box {
        display: flex;
        justify-content: space-around;
        margin-top: 5px;
        .opt-btn {
            border-radius: 25px;
            width: 50px;
            height: 24px;
            background-color: #e7eaf3;
            color: #000000;
            border: none;
        }
    }
}
</style>